import React from "react";
import { TextField, Stack, mergeStyles } from "@fluentui/react";
import { styles } from "../ExperimentDetailsForm/experimentDetailsForm.styles";
import { FIELD_TOOLTIPS } from "../ExperimentDetailsForm/ExperimentDetailsValidation/experimentDetailsFormValidation";
import BaseLabelRenderer from "./BaseLabelRenderer";

interface BaseTextFieldProps {
  fieldKey: keyof any;
  label: string;
  value: string;
  isRequired?: boolean;
  isEdit: boolean;
  multiline?: boolean;
  subtitle?: string;
  errorMessage?: string[];
  onChange: (fieldKey: string, value: string | undefined) => void;
  grow?: boolean;
  className?: string;
  [key: string]: any;
}

const BaseTextField: React.FC<BaseTextFieldProps> = ({
  fieldKey,
  label,
  value,
  isRequired = false,
  isEdit,
  multiline = false,
  subtitle,
  errorMessage,
  onChange,
  grow = false,
  className,
  ...rest
}) => {
  const hasTooltip = FIELD_TOOLTIPS[fieldKey as string];

  const fieldProps = {
    title: value,
    value: value || "",
    readOnly: !isEdit,
    disabled: !isEdit,
    onChange: isEdit
      ? (e: any, v?: string) => onChange(fieldKey as string, v)
      : undefined,
    errorMessage:
      errorMessage && errorMessage.length > 0
        ? errorMessage.join("; ")
        : undefined,
    multiline,
    ...rest,
  };

  if (grow) {
    return (
      <Stack grow>
        <BaseLabelRenderer
          label={label}
          isRequired={isRequired}
          tooltip={hasTooltip}
          description={subtitle}
        />
        <TextField
          {...fieldProps}
          className={mergeStyles(
            className || styles.experimentDetailsFormColStyle,
            !fieldProps.disabled && styles.experimentDetailsTextField,
          )}
        />
      </Stack>
    );
  }

  return (
    <div className={styles.experimentDetailsLabelContainer}>
      <BaseLabelRenderer
        label={label}
        isRequired={isRequired}
        tooltip={hasTooltip}
        description={subtitle}
      />
      <TextField
        {...fieldProps}
        className={mergeStyles(
          className || styles.experimentDetailsFormColStyle,
          !fieldProps.disabled && styles.experimentDetailsTextField,
        )}
      />
    </div>
  );
};

export default BaseTextField;
